const calculationHelpers = {}

/**
 * calculateLatLongDistance - calculate the distance between two places, with latitude and longitude
 * http://stackoverflow.com/a/21623206
 *
 * @param {object} [locationOne={}] Location one
 * @param {object} [locationTwo={}] Location two
 * @param {Number} [precision=1] used to return a number with x amount of decimal places
 *
 * @return {type} Description
 */
calculationHelpers.calculateLatLongDistance = (locationOne = {}, locationTwo = {}, precision = 1) => {
  if (locationOne.lat && locationTwo.lat && locationOne.long && locationTwo.long) {
    // Math.PI / 180
    const p = 0.017453292519943295
    const c = Math.cos
    const a = 0.5 - c((locationTwo.lat - locationOne.lat) * p) / 2 +
      c(locationOne.lat * p) * c(locationTwo.lat * p) *
      (1 - c((locationTwo.long - locationOne.long) * p)) / 2

    // 2 * R; R = 6371 km
    const returnValue = 12742 * Math.asin(Math.sqrt(a))
    return returnValue.toFixed(precision)
  }
  return null
}

export default calculationHelpers
